import { useEffect, useState } from 'react';
import type { SiteMeta } from '../types';
import { api } from './api';

let cached: SiteMeta | null = null;
let inflight: Promise<SiteMeta> | null = null;

export async function loadMeta(): Promise<SiteMeta> {
  if (cached) return cached;
  if (inflight) return inflight;
  inflight = api.meta().then((m) => {
    cached = m;
    inflight = null;
    return m;
  });
  return inflight;
}

export function useMeta(): SiteMeta | null {
  const [meta, setMeta] = useState<SiteMeta | null>(cached);
  useEffect(() => {
    let mounted = true;
    if (!cached) {
      loadMeta().then((m) => {
        if (mounted) setMeta(m);
      }).catch(() => {/* ignore */});
    }
    return () => { mounted = false; };
  }, []);
  return meta;
}
